class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('[role="tab"]');
    this.tabPanels = this.querySelectorAll('[role="tabpanel"]');
    this.tabButtons.forEach(button => button.addEventListener('click', this.handleTabOnClick.bind(this)));
  }

  handleTabOnClick (event) {
    event.stopPropagation();
    this.tabPanels.forEach(panel => {
      panel.hidden = true;
    });
    this.tabButtons.forEach(tab => {
      tab.setAttribute('aria-selected', false);
    });
    event.currentTarget.setAttribute('aria-selected', true);
    const tabPanel = this.querySelector(`[aria-labelledby="${event.currentTarget.id}"]`);
    tabPanel.hidden = false;
  }
}

customElements.define('tabs-component', TabsComponent);